import { ChangeDetectionStrategy, Component, HostListener, inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarLabel, MatSnackBarRef } from "@angular/material/snack-bar";

/**
 * Snackbar body used by NotificationService. It carries no action button:
 * clicking anywhere on the snackbar dismisses it, mirroring the tap-to-dismiss
 * behaviour the app had under ngx-toastr.
 */
@Component({
	selector: "app-notification-snackbar",
	imports: [MatSnackBarLabel],
	templateUrl: "./notification-snackbar.component.html",
	styleUrl: "./notification-snackbar.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationSnackbarComponent {
	readonly message = inject<string>(MAT_SNACK_BAR_DATA);

	private snackBarRef = inject<MatSnackBarRef<NotificationSnackbarComponent>>(MatSnackBarRef);

	@HostListener("click")
	dismiss(): void {
		this.snackBarRef.dismiss();
	}
}
